import * as yup from 'yup'
import { AutocompleteFacilityValueSchema } from './AutocompleteFacilityValueSchema'

export const MIN_WEIGHT_VALUE_ERROR = 'Min Weight must be less than Max Weight.'
export const MAX_WEIGHT_VALUE_ERROR = 'Max Weight must be more than Min Weight'

export const MIN_WEIGHT_REQUIRED_ERROR = 'Min Weight is required if Weight Type is a range.'
export const MAX_WEIGHT_REQUIRED_ERROR = 'Max Weight is required if Weight Type is a range.'

export enum WeightType {
  single = 'single',
  range = 'range',
}

export const LaneDetailsSchema = yup.object({
  commodity: yup.string().nullable(),
  weightType: yup.string().oneOf(Object.values(WeightType)).default(WeightType.single).required(),
  minWeight: yup
    .number()
    .moreThan(0)
    .nullable()
    .transform(value => value || null)
    .when('weightType', {
      is: weightType => weightType === WeightType.range,
      then: yup
        .number()
        .lessThan(yup.ref('maxWeight'), MIN_WEIGHT_VALUE_ERROR)
        .required(MIN_WEIGHT_REQUIRED_ERROR)
        .typeError(MIN_WEIGHT_REQUIRED_ERROR),
    }),
  maxWeight: yup
    .number()
    .moreThan(0)
    .nullable()
    .transform(value => value || null)
    .when('weightType', {
      is: weightType => weightType === WeightType.range,
      then: yup
        .number()
        .moreThan(yup.ref('minWeight'), MAX_WEIGHT_VALUE_ERROR)
        .required(MAX_WEIGHT_REQUIRED_ERROR)
        .typeError(MAX_WEIGHT_REQUIRED_ERROR),
    }),
  note: yup.string().nullable(),
  offerLeadTime: yup
    .number()
    .integer()
    .moreThan(0)
    .nullable()
    .transform(value => value || null),
  pickupFacility: AutocompleteFacilityValueSchema.nullable(),
  deliveryFacility: AutocompleteFacilityValueSchema.nullable(),
})

export type TLaneDetailsSchema = yup.InferType<typeof LaneDetailsSchema>
